import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faSatelliteDish,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import { HoverCard, HoverIcon } from "../components/HoverMotion";

const serviceCards = [
  {
    icon: faSatelliteDish,
    title: "Live GPS Tracking",
    text: "Monitor participants, teams, and assets from a live event map with near-real-time location updates.",
  },
  {
    icon: faShieldHalved,
    title: "Safety Support",
    text: "Give race control, medical teams, sweepers, and field crews better visibility during the event.",
  },
  {
    icon: faChartLine,
    title: "Operational Review",
    text: "Use tracking history to review movement, support incidents, and understand how the event unfolded.",
  },
];


export const SectionHero = () => {
  return (
    <div id="hero" className="min-h-screen bg-white flex flex-col relative">
      {/* HERO SECTION */}
      <div className="relative w-full h-[65vh] md:h-[65vh] z-10">
        <img
          src="/bg/bghero1.jpg"
          alt="Events Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 to-gray-900/30"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-6">
          <Link to="/" aria-label="VionixAsia Home" className="inline-block">
            <motion.img
              src="/vionixwhite.png"
              alt="VionixAsia"
              className="h-24 md:h-32 object-contain"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            />
          </Link>

          <motion.p
            className="text-base md:text-lg font-normal text-white max-w-2xl mx-auto tracking-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.15 }}
          >
            Welcome to TRACKING VIONIXASIA — versatile GPS trackers for running, cycling, and field operations. Near-real-time location updates for participants, teams, and assets.
          </motion.p>
        </div>
      </div>

      {/* SERVICE OVERVIEW */}
      <section className="w-full bg-white border-t border-slate-200 relative z-10">
        <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3">
            Tracking Service
          </h1>
          <p className="text-gray-600 max-w-3xl mx-auto">
            TRACKING VIONIXASIA helps organizers monitor endurance events and field operations with GPS devices, live maps, and movement history.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {serviceCards.map((card, index) => (
            <HoverCard
              key={card.title}
              className={`p-4 h-full flex items-start gap-4 rounded-card border border-slate-200 ${
                index === 1 ? "bg-slate-900" : "bg-white"
              }`}
            >
              <HoverIcon
                className={`w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-icon border ${
                  index === 1
                    ? "bg-white/10 border-white/20 text-white"
                    : "bg-slate-100 border-slate-200 text-slate-700"
                }`}
              >
                <FontAwesomeIcon icon={card.icon} className="w-5 h-5" />
              </HoverIcon>
              <div className="flex-1">
                <h2
                  className={`text-lg font-bold mb-1 ${
                    index === 1 ? "text-white" : "text-slate-900"
                  }`}
                >
                  {card.title}
                </h2>
                <p
                  className={`text-sm leading-relaxed ${
                    index === 1 ? "text-slate-300" : "text-slate-600"
                  }`}
                >
                  {card.text}
                </p>
              </div>
            </HoverCard>
          ))}
        </div>
        </div>
      </section>
    </div>
  );
};
